import { useElementSize } from "../../hooks/mantine-passthroughs/index.js";
import { StickyFooterProviderContext } from "./StickyFooterProviderContext.js";
import sticky_footer_module_default from "./sticky-footer.module.js";
import { AppShell, Box, Portal, Stack } from "@mantine/core";
import { useContext, useEffect } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";

//#region src/components/sticky-footer/StickyFooter.tsx
const StickyFooter = ({ children, active = false, color, includeAppFooter = true, "data-testid": testId }) => {
	const stickyFooterCtx = useContext(StickyFooterProviderContext);
	const { ref, height } = useElementSize();
	if (!stickyFooterCtx) throw new Error("A StickyFooter component can only be used from within the content of the app");
	const { appFooter, maxWidth, setFooterHeight, setHasStickyFooter, stickyFooterTarget } = stickyFooterCtx;
	useEffect(() => {
		if (active) {
			setFooterHeight(height);
			setHasStickyFooter?.(true);
		}
		return () => setHasStickyFooter?.(false);
	}, [
		active,
		height,
		setFooterHeight,
		setHasStickyFooter
	]);
	if (!active) return /* @__PURE__ */ jsx(Fragment$1, { children });
	return /* @__PURE__ */ jsx(Portal, {
		target: stickyFooterTarget?.current ?? void 0,
		children: /* @__PURE__ */ jsx(AppShell.Footer, {
			bottom: 0,
			p: "sm",
			bg: color ?? void 0,
			ref,
			classNames: sticky_footer_module_default,
			"data-testid": testId,
			children: /* @__PURE__ */ jsx(Box, {
				w: "100%",
				maw: maxWidth,
				m: "0 auto",
				children: /* @__PURE__ */ jsxs(Stack, {
					gap: "xl",
					children: [children, includeAppFooter && appFooter ? /* @__PURE__ */ jsx(Box, {
						p: "sm",
						pb: 0,
						children: appFooter
					}) : null]
				})
			})
		})
	});
};

//#endregion
export { StickyFooter };